export enum ChartVersionStatusEnum {
    none = 1,
    current, // текущий
    approved, // утвержден
    archive, // архивный
    onApproval, // на утверждении
    cancelled, // отклонен
}
